import styled from "styled-components";

export const Error404 = styled.div`
    width: 100%;
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color:${props => props.theme.colors.background};
    img{
        width: 30rem;
        height: 30rem;
        @media screen and (max-width: 800px) {
            width: 18rem;
            height: 18rem;
        }
    }
    h1{
        color: ${props => props.theme.colors.white};
        text-align: center;
    }
`